import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // window.gtag?.('event', 'page_view', {
    //   page_path: location.pathname,
    //   page_title: document.title,
    // });
    // eslint-disable-next-line no-console
    // console.log('Path', location.pathname);
    // log(settings?.configs.showLogs, 'Path', location.pathname);
  }, [location]);

  return null;
};
